export default __webpack_public_path__ + "static/media/CentraNo2-Book.ed352130.eot";